import React, {useEffect, useState} from 'react';
import { MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import dxDataGrid from 'devextreme/ui/data_grid';

export interface IIndMasterDetail{
    id: string;
    status: any;
	dataColumns: any;
    schema: any;
    data: any;
    gridId: any;
    screen: string;
    onSelectionChanged?(newValue: any): void;
    currentYear: any;
    tourData?: any;
}

const IndMasterDetail: React.FC<IIndMasterDetail> = (props) => {
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState(props.data);
    const [parentGrid, setParentGrid] = useState<dxDataGrid>();

    const view: IFollowupSubproject = {
		state: {
			dataColumns: props.dataColumns
		},
  	};

	const presenter = new FollowupSubProjectPresenter(view);  

    const onSelectionChanged = (data:any) => {
        if(data.selectedRowsData.length > 0 && parentGrid !== undefined){ 
            const selectedRows: any = parentGrid.getSelectedRowsData();
            selectedRows[0].selected = true;            
            const dataSource:any = parentGrid.getDataSource().items(); 
            const deselected = dataSource.find((X:any) => X.id === data.currentDeselectedRowKeys[0])  
            if(deselected !== undefined){
                deselected.selected = false;
            }                                
            parentGrid.option("selectedRowsData", selectedRows);  
            parentGrid.option("dataSource", dataSource);
            
            //add detail data
            const items: any = data.selectedRowsData
            setData(items);
        } else {
            setData([]);
        }
    }

    useEffect(()=>{
        if(props.data > 0){  
            setData(data); 
        }
        if(props.gridId  !== undefined){
            const container = document.getElementById(props.gridId) as HTMLElement;
            const instance = dxDataGrid.getInstance(container) as dxDataGrid;
            setParentGrid(instance)
        }
    },[props])

    useEffect(()=>{
        parentGrid?.option('onSelectionChanged',onSelectionChanged);
    },[parentGrid]);

    useEffect(()=>{
        if(props.dataColumns?._values?.length){
            const auxCol = presenter.getMonthsDetailsColumns(props.status, props.currentYear); 
            setColumns(auxCol) 
        }
    },[props.status?.CodigoDimension, props.dataColumns, presenter.subProjectMonths, props.status?.EnEdicion, presenter.tourIndSeen]);

    return (
        <>
        {(data && props.status && columns) ?
            <MasterDataGrid                
                id={props.id}
                dataSource={props.tourData || data}
                columns={columns}
                key={"id"}
                allowCode={props.screen}
                gridProps={{
                    editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
                    rowAlternationEnabled:false,
                    onRowUpdated: (e) => { 
                        if(parentGrid !== undefined){
                            const dataSource:any = parentGrid.getDataSource().items();
                            const items = [...dataSource];
                            parentGrid.option("dataSource",items);
                            
                            //Fake editing in parentGrid
                            var keys = parentGrid.getSelectedRowKeys()
                            if (keys.length) {
                                let idx = parentGrid.getRowIndexByKey(keys[0])
                                parentGrid.cellValue(idx, 1, items[idx].indicator);
                            }
                        } 
                    }                    
                }}
            />    
            : <></>
        }
        </>
    )
}

export default IndMasterDetail;
